export const CATEGORIES = [
    {
        id: 'ALL',
        name: 'ALL',
        symbol: '',
    },
    {
        id: 'ALPHA',
        name: 'ALPHABET',
        symbol: '🔤',
    },
    {
        id: 'NUM',
        name: 'NUMBER',
        symbol: '🔢',
    },
    {
        id: 'ARROW',
        name: 'ARROW',
        symbol: '➡️',
    },
    {
        id: 'SMILEY',
        name: 'SMILEY',
        symbol: '😃',
    },
    {
        id: 'DECO',
        name: 'DECO',
        symbol: '💘',
    },
    {
        id: 'INDEX',
        name: 'INDEX',
        symbol: '🗂️',
    },
    {
        id: 'LABEL',
        name: 'LABEL',
        symbol: '🏷️',
    },
]

const CATEGORY = {
    ALPHA: {
        name: 'ALPHABET',
        symbol: '🔤',
    },
    NUM: { name: 'NUMBER', symbol: '🔢' },
    ARROW: { name: 'ARROW', symbol: '➡️' },
    SMILEY: { name: 'SMILEY', symbol: '😃' },
    REWARD: { name: 'REWARD', symbol: '⭐︎' },
    DECO: { name: 'DECO', symbol: '💘' },
    INDEX: { name: 'INDEX', symbol: '🗂️' },
    LABEL: { name: 'LABEL', symbol: '🏷️' },
}

export const PRODUCTS = [
    {
        title: 'ALPHA 01',
        subtitle: '9mm Circle Alphabets A-Z',
        price: 20,
        image: 'alpha01',
        category: CATEGORY.ALPHA,
        quantity: 7,
        weight: 22,
    },
    {
        title: 'NUM 01',
        subtitle: '9mm Circle Numbers 1-100',
        price: 20,
        image: 'num01',
        category: CATEGORY.NUM,
        quantity: 6,
        weight: 25,
    },
    {
        title: 'NUM 02',
        subtitle: '10mm Circle Numbers Glossy 1-100',
        price: 15,
        image: 'num02',
        category: CATEGORY.NUM,
        quantity: 23,
        weight: 27,
    },
    {
        title: 'NUM 03',
        subtitle: '15mm Circle Numbers Glossy 1-100',
        price: 7,
        image: 'num03',
        category: CATEGORY.NUM,
        quantity: 23,
        weight: 24,
    },
    {
        title: 'NUM 04',
        subtitle: '10mm Circle Numbers Matte 1-100',
        price: 15,
        image: 'num04',
        category: CATEGORY.NUM,
        quantity: 22,
        weight: 56,
    },
    {
        title: 'NUM 05',
        subtitle: '15mm Circle Numbers Matte 1-100',
        price: 15,
        image: 'num05',
        category: CATEGORY.NUM,
        quantity: 23,
        weight: 113,
    },
    {
        title: 'NUM 6.1',
        subtitle: 'Outline Circle Numbers 1-50 (Red)',
        price: 1,
        image: 'num06',
        category: CATEGORY.NUM,
        quantity: 10,
        weight: 2,
    },
    {
        title: 'NUM 6.2',
        subtitle: 'Outline Circle Numbers 1-50 (Orange)',
        price: 1,
        image: 'num06',
        category: CATEGORY.NUM,
        quantity: 3,
        weight: 2,
    },
    {
        title: 'ARROW 01',
        subtitle: 'Fluorescent Arrow',
        price: 25,
        image: 'arrow01',
        category: CATEGORY.ARROW,
        quantity: 7,
        weight: 35,
    },
    {
        title: 'ARROW 02',
        subtitle: 'Classic Arrow',
        price: 20,
        image: 'arrow02',
        category: CATEGORY.ARROW,
        quantity: 16,
        weight: 30,
    },
    {
        title: 'ARROW 03',
        subtitle: 'Quads Arrow',
        price: 10,
        image: 'arrow03',
        category: CATEGORY.ARROW,
        quantity: 21,
        weight: 24,
    },
    {
        title: 'SMILEY 01',
        subtitle: 'Fluorescent Smileys',
        price: 30,
        image: 'smiley01',
        category: CATEGORY.SMILEY,
        quantity: 24,
        weight: 32,
    },
    {
        title: 'SMILEY 02',
        subtitle: 'Classic Smileys',
        price: 15,
        image: 'smiley02',
        category: CATEGORY.SMILEY,
        quantity: 28,
        weight: 37,
    },
    {
        title: 'SMILEY 03',
        subtitle: 'Golden Smileys',
        price: 10,
        image: 'smiley03',
        category: CATEGORY.SMILEY,
        quantity: 14,
        weight: 25,
    },
    {
        title: 'SMILEY 4.1',
        subtitle: 'Special Smileys',
        price: 2,
        image: 'smiley04-i',
        category: CATEGORY.SMILEY,
        quantity: 40,
        weight: 6,
    },
    {
        title: 'SMILEY 4.2',
        subtitle: 'Special Smileys',
        price: 2,
        image: 'smiley04-ii',
        category: CATEGORY.SMILEY,
        quantity: 8,
        weight: 3,
    },
    {
        title: 'SMILEY 4.3',
        subtitle: 'Special Smileys',
        price: 2,
        image: 'smiley04-iii',
        category: CATEGORY.SMILEY,
        quantity: 7,
        weight: 3,
    },
    {
        title: 'SMILEY 4.4',
        subtitle: 'Special Smileys',
        price: 2,
        image: 'smiley04-iv',
        category: CATEGORY.SMILEY,
        quantity: 8,
        weight: 3,
    },
    {
        title: 'DECO 01',
        subtitle: 'Fluorescent Mix',
        price: 30,
        image: 'deco01',
        category: CATEGORY.DECO,
        quantity: 18,
        weight: 51,
    },
    {
        title: 'DECO 02',
        subtitle: 'Classic Hearts',
        price: 5,
        image: 'deco02',
        category: CATEGORY.DECO,
        quantity: 20,
        weight: 5,
    },
    {
        title: 'INDEX 01',
        subtitle: 'Colorful Index',
        price: 10,
        image: 'index01',
        category: CATEGORY.INDEX,
        quantity: 12,
        weight: 38,
    },
    {
        title: 'INDEX 02',
        subtitle: 'Special Mix',
        price: 5,
        image: 'index02',
        category: CATEGORY.INDEX,
        quantity: 6,
        weight: 12,
    },
    {
        title: 'LABEL 01',
        subtitle: 'Special Mix',
        price: 12,
        image: 'label01',
        category: CATEGORY.LABEL,
        quantity: 6,
        weight: 21,
    },
    {
        title: 'LABEL 02',
        subtitle: 'Pastel & Fluorescent Tags',
        price: 10,
        image: 'label02',
        category: CATEGORY.LABEL,
        quantity: 20,
        weight: 10,
    },
]
